export const BlogHeader = () => {
  return `query HeaderText($status: PublicationStatus, $locale: I18NLocaleCode) {
  headerText(status: $status, locale: $locale) {
    documentId
    title
    locale
    headerText
    createdAt
    updatedAt
    publishedAt
  }
}`;
};
